/*  ========================================================================
    # Scripts - Accordions
    ========================================================================  */

/**
 * Script that handles the opening and closing of the accordions.
 */

const Accordions = {
  cfg: {
    accordionBlock: document.querySelectorAll('.b-accordion'),
    entries: document.querySelectorAll('.s-accordion__entry'),
    entryHeaderClass: 's-accordion__entry-header',
    states: {
      openAccordion: 's-accordion__entry--open'
    }
  },

  /**
   * Handle accordion.
   */
  handleAccordions() {
    this.cfg.entries.forEach(entry => {
      const header = entry.querySelector(`.${this.cfg.entryHeaderClass}`);
      header.addEventListener('click', () => {
        if (entry.classList.contains(this.cfg.states.openAccordion)) {
          entry.classList.remove(this.cfg.states.openAccordion);
        } else {
          const allOpenedElements = document.getElementsByClassName(this.cfg.states.openAccordion);
          if (allOpenedElements.length > 0) {
            for (let i = 0; i < allOpenedElements.length; i++) {
              allOpenedElements[i].classList.remove(this.cfg.states.openAccordion);

              if (allOpenedElements[i] === entry) {
                return;
              }
            }
          }

          entry.classList.add(this.cfg.states.openAccordion);
        }
      });
    });
  },

  /**
   * Handle accordion.
   */
  handleAccordionBlock() {
    this.cfg.accordionBlock.forEach(block => {
      const entries = block.querySelectorAll('.b-accordion__entry');
      if (entries.length > 0) {
        entries.forEach(entry => {
          const header = entry.querySelector('.b-accordion__title')
          if (header) {
            header.addEventListener('click', () => {
              entry.classList.toggle('open');
            });
          }
        });
      }
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.entries) {
      this.handleAccordions();
    }

    if (this.cfg.accordionBlock) {
      this.handleAccordionBlock();
    }
  }
};

export default Accordions;
